import { usePostHog } from 'posthog-js/react';

import { useUser } from 'shared/hooks/api/user';

export const DEMO_ORG_NAME = 'Doughlicious';
export const DEMO_INSTANT_REFLEX_FLAG = 'demo_instant_reflex';

const POSTHOG_ENABLED = import.meta.env.REACT_APP_POSTHOG_ENABLED === 'true';

export default function useIsDemoReflex(): boolean {
  const { data: user } = useUser();
  const posthog = usePostHog();

  const isDemoOrganization = user?.organization?.name === DEMO_ORG_NAME;
  const isFlagEnabled = POSTHOG_ENABLED
    ? !!posthog?.isFeatureEnabled(DEMO_INSTANT_REFLEX_FLAG)
    : true;

  return isDemoOrganization && isFlagEnabled;
}
